export type SupplierPdfDraftContentInput = {
  baseSubject?: string;
  organizationName?: string;
  customerName?: string;
  customerReference: string;
};

export type SupplierPdfFileNameInput = {
  customerReference: string;
  customerName?: string;
};

export type SupplierPdfDraftContent = {
  subject: string;
  htmlBody: string;
};

/**
 * Central place to edit subject/body for the supplier draft with PDF attachment.
 * Keep this intentionally simple so non-technical users can tweak wording quickly.
 */
export function buildSupplierPdfDraftContent(
  input: SupplierPdfDraftContentInput
): SupplierPdfDraftContent {
  const safeRef = String(input.customerReference || '').trim();
  const orgRaw = String(input.organizationName || '').trim();
  const orgWithLtd = /(?:\bltd\b|limited)$/i.test(orgRaw) || !orgRaw
    ? orgRaw
    : `${orgRaw} Ltd`;
  const customerRaw = String(input.customerName || '').trim();
  const customerLastName = customerRaw ? customerRaw.split(/\s+/).slice(-1)[0] : '';
  const customerLastNameUpper = customerLastName ? customerLastName.toUpperCase() : '';
  const subject =
    orgWithLtd && safeRef && customerLastNameUpper
      ? `${orgWithLtd} - Price Request - ${safeRef} - ${customerLastNameUpper}`
      : String(input.baseSubject || '').trim() || `Price Request - ${safeRef || 'Reference'}`;
  const htmlBody = `<p>Dear Supplier</p><p>Please quote the items in the attached PDF${safeRef ? ` for ${safeRef}` : ''} ${customerLastNameUpper ? ` - ${customerLastNameUpper}` : ''}.</p><p>Kind Regards</p><p>Keystone Glazing Team</p>`;
  return { subject, htmlBody };
}

/**
 * Central place to control supplier PDF filename convention.
 */
export function buildSupplierPdfFileName(input: SupplierPdfFileNameInput): string {
  const safeRef = String(input.customerReference || "document")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9._-]/g, "");
  const customerRaw = String(input.customerName || '').trim();
  const customerLastName = customerRaw ? customerRaw.split(/\s+/).slice(-1)[0] : '';
  const customerLastNameUpper = customerLastName
    ? customerLastName.toUpperCase().replace(/[^A-Z0-9_-]/g, '')
    : '';
  const suffix = customerLastNameUpper ? `-${customerLastNameUpper}` : '';
  return `keystoneglazing-quote-export-${safeRef}${suffix}.pdf`;
}
